import { Typography } from '@krakentech/coral';
import { motion } from 'framer-motion';
import styled from 'styled-components';

export const StyledWheelOfFortune = styled(motion.div)`
  font-size: 16px;
  position: relative;
  width: 400px;
  height: 400px;
  margin: 0 auto;
  border-radius: 50%;

  @media (max-width: 768px) {
    width: 300px;
    height: 300px;
  }

  @media (max-width: 480px) {
    width: 250px;
    height: 250px;
  }
`;

export const WheelButton = styled(motion.button)`
  position: relative;
  width: 100%;
  height: 100%;
  border: none;
  background: none;
  cursor: pointer;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const WheelSVG = styled.svg`
  width: 100%;
  height: 100%;
  transform-origin: center;
  filter: drop-shadow(0 8px 16px rgba(0, 0, 0, 0.1));
`;

export const Pointer = styled(motion.div)`
  position: absolute;
  top: -10px;
  left: 50%;
  transform: translateX(-50%);
  width: 0;
  height: 0;
  border-left: 10px solid transparent;
  border-right: 10px solid transparent;
  border-top: 20px solid #333;
  z-index: 10;
  filter: drop-shadow(0 2px 4px rgba(0, 0, 0, 0.2));

  @media (max-width: 768px) {
    top: -8px;
    border-left: 8px solid transparent;
    border-right: 8px solid transparent;
    border-top: 16px solid #333;
  }

  @media (max-width: 480px) {
    top: -6px;
    border-left: 6px solid transparent;
    border-right: 6px solid transparent;
    border-top: 12px solid #333;
  }
`;

export const Title = styled(Typography)`
  margin-bottom: 20px;
`;

export const Subtitle = styled(Typography)`
  margin-bottom: 30px;
`;

export const StatusText = styled(Typography)`
  margin-top: 20px;
`;
